import { createAsyncThunk } from "@reduxjs/toolkit";
import API_ROUTES from "../../../constants/apiRoutes";
import { createProfileAPI } from "../../../constants/reduxConstant";
import { getAuthorization } from "../../../services/config";
import { updateLoading } from "../loader";
import rollbar from "../../../rollbarConfig";

const {
  tags = "",
  create_profile = "",
  shopify_profile = "",
  seller_profile = "",
  seller_collections = "",
  seller_categories = "",
  create_product = "",
  seller_products = "",
  shopify_list = "",
  connect_stripe = "",
  dashboard= "",
  seller_edit_products = "",
  get_product_id = "",
  seller_delete_products = "",
  seller_mark_shipped = "",
  seller_edit_profile,
  migrate_inventory = "",
  shopify_status = "",
  seller_colours = "",
  seller_sizes = "",
  seller_add_colours = "",
  seller_add_sizes = "",
  option_types = "",
  create_option_type = "",
  create_option_value = "",
  get_product_variants = "",
  update_product_options = "",
  update_product_variants = "",
  update_variant = "",
  delete_variant = ""
} = createProfileAPI;
const {
  V1: {
    TAGS,
    CREATE_PROFILE,
    SELLER_PROFILE,
    SHOPIFY_PROFILE,
    SELLER_COLLECTIONS,
    SELLER_CATEGORIES,
    CREATE_PRODUCT,
    SHOPIFY_LIST,
    GET_PRODUCT,
    GET_CONNECT_STRIPE,
    GET_FAVOURITES,
    GET_ORDERS,
    GET_FILTER_BY_STOCK,
    GET_SELLER_DASHBOARD,
    GET_SELLER_MARK_SHIPPED,
    STATUS_COLOR,
    MIGRATE_INVENTORY,
    SHOPIFY_STATUS,
    SELLER_COLOURS,
    SELLER_SIZES,
    SHOPIFY_ACCOUNT_CHECK,
    OPTION_TYPES,
    OPTION_TYPE_DETAIL,
    OPTION_VALUES,
    PRODUCT_VARIANTS,
    UPDATE_VARIANT,
    DELETE_VARIANT
  } = {},
} = API_ROUTES;

const fetchTags = createAsyncThunk(tags, async (_, { dispatch, getState }) => {
  const API = getAuthorization(getState, dispatch,);
  try {
    dispatch(updateLoading(true));
    const response = await API.get(TAGS);
  
    return response?.data;
  } catch (err) {
    rollbar.error("Error message", err);
    return err;
  } finally {
    dispatch(updateLoading(false));
  }
});

const fetchFavProducts = createAsyncThunk(dashboard, async (params="", { dispatch, getState }) => {
  const API = getAuthorization(getState, dispatch,  { isAuthHeader: true });
  try {

    const response = await API.get(GET_FAVOURITES+params);

    return response?.data;
  } catch (err) {
    rollbar.error("Error message", err);
    return err;
  }
});

const fetchOrders = createAsyncThunk(dashboard, async (params, { dispatch, getState }) => {
  const API = getAuthorization(getState, dispatch,  { isAuthHeader: true });
  try {

    const response = await API.get(GET_ORDERS+params);

    return response;
  } catch (err) {
    rollbar.error("Error message", err);
    return err;
  }
});


const fetchDashboardData = createAsyncThunk(dashboard, async (_, { dispatch, getState }) => {
  const API = getAuthorization(getState, dispatch,  { isAuthHeader: true });
  try {

    const response = await API.get(GET_SELLER_DASHBOARD);

    return response;
  } catch (err) {
    rollbar.error("Error message", err);
    return err;
  }
});


const fetchFilteredByStockProducts = createAsyncThunk(dashboard, async (params, { dispatch, getState }) => {
  const API = getAuthorization(getState, dispatch,  { isAuthHeader: true });
  try {
  
    const response = await API.get(GET_FILTER_BY_STOCK+params);

    return response?.data;
  } catch (err) {
    rollbar.error("Error message", err);
    return err;
  }
});


const fetchCollections = createAsyncThunk(
  seller_collections,
  async (_, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch,);
    try {
      dispatch(updateLoading(true));
      const response = await API.get(SELLER_COLLECTIONS);
   
      return response?.data;
    } catch (err) {
      rollbar.error("Error message", err);
      return err;
    }finally {
      dispatch(updateLoading(false));
    }
  }
);
const fetchShopifyStatus = createAsyncThunk(
  shopify_status,
  async (_, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch, { isAuthHeader: true });
    try {
      dispatch(updateLoading(true));
      const response = await API.get(SHOPIFY_STATUS); 
      return response?.data;
    } catch (err) {
      rollbar.error("Error message", err);
      return err;
    }finally {
      dispatch(updateLoading(false)); 
    }
  }
);

const fetchCategories = createAsyncThunk(
  seller_categories,
  async (_, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch,);
    try {
      dispatch(updateLoading(true));
      const response = await API.get(SELLER_CATEGORIES);
 
      return response?.data;
    } catch (err) {
      rollbar.error("Error message", err);
      return err;
    }finally {
      dispatch(updateLoading(false));
    }
  }
);

const fetchColours = createAsyncThunk(
  seller_colours,
  async (_, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch,);
    try {
      dispatch(updateLoading(true));
      const response = await API.get(SELLER_COLOURS);
 
      return response?.data;
    } catch (err) {
      rollbar.error("Error message", err);
      return err;
    }finally {
      dispatch(updateLoading(false));
    }
  }
);

const fetchSizes = createAsyncThunk(
  seller_sizes,
  async (_, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch,);
    try {
      dispatch(updateLoading(true));
      const response = await API.get(SELLER_SIZES);
 
      return response?.data;
    } catch (err) {
      rollbar.error("Error message", err);
      return err;
    }finally {
      dispatch(updateLoading(false));
    }
  }
);

const fetchAddColours = createAsyncThunk(
  seller_add_colours,
  async (data, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch, { isAuthHeader: true });
    try {
      const response = await API.post(SELLER_COLOURS, data);
      return response?.data;
    } catch (err) {
      rollbar.error("Error message", err);
      return err;
    }
  }
);

const fetchAddSizes = createAsyncThunk(
  seller_add_sizes,
  async (data, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch, { isAuthHeader: true });
    try {
      const response = await API.post(SELLER_SIZES, data);
      return response?.data;
    } catch (err) {
      rollbar.error("Error message", err);
      return err;
    }
  }
);

const fetchOptionTypes = createAsyncThunk(
  option_types,
  async (_, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch, { isAuthHeader: true });
    try {
      dispatch(updateLoading(true));
      const response = await API.get(OPTION_TYPES);
      return response?.data;
    } catch (err) {
      rollbar.error("Error message", err);
      return err;
    } finally {
      dispatch(updateLoading(false));
    }
  }
);

const fetchOptionTypeDetail = createAsyncThunk(
  "createProfile/fetchOptionTypeDetail",
  async (id, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch, { isAuthHeader: true });
    try {
      dispatch(updateLoading(true));
      const url = OPTION_TYPE_DETAIL.replace(':id', id);
      const response = await API.get(url);
      return response?.data;
    } catch (err) {
      rollbar.error("Error message", err);
      return err;
    } finally {
      dispatch(updateLoading(false));
    }
  }
);

const fetchCreateOptionType = createAsyncThunk(
  create_option_type,
  async (data, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch, { isAuthHeader: true });
    try {
      dispatch(updateLoading(true));
      const response = await API.post(OPTION_TYPES, data);
      return response?.data;
    } catch (err) {
      rollbar.error("Error creating option type", err);
      return err;
    } finally {
      dispatch(updateLoading(false));
    }
  }
);

const fetchCreateOptionValue = createAsyncThunk(
  create_option_value,
  async (data, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch, { isAuthHeader: true });
    try {
      const response = await API.post(OPTION_VALUES, data);
      return response?.data;
    } catch (err) {
      rollbar.error("Error creating option value", err);
      return err;
    }
  }
);

const fetchCreateProfile = createAsyncThunk(
  create_profile,
  async (data, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch, { isAuthHeader: true });
    try {
      dispatch(updateLoading(true));
      const response = await API.patch(CREATE_PROFILE, data);

      return response?.data;
    } catch (err) {
      rollbar.error("Error message", err);
      return err;
    } finally {
      dispatch(updateLoading(false));
    }
  }
);
const fetchShopifyProfile = createAsyncThunk(
  shopify_profile,
  async (params="", { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch, { isAuthHeader: true });
    try {
      dispatch(updateLoading(true));
      const response = await API.get(SHOPIFY_PROFILE+params);
      return response?.data;
    } catch (err) {
      rollbar.error("Error message", err);
      return err;
    } finally {
      dispatch(updateLoading(false));
    }
  }
);
const fetchShopifyList = createAsyncThunk(
  shopify_list,
  async (params="", { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch, { isAuthHeader: true });
    try {
      dispatch(updateLoading(true));
      const response = await API.get(SHOPIFY_LIST + params);
      return response?.data;
    } catch (err) {
      return err;
    } finally {
      dispatch(updateLoading(false));
    }
  }
);
const fetchCreateProduct = createAsyncThunk(
  create_product,
  async (data, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch, { isAuthHeader: true });
    try {
      dispatch(updateLoading(true));
      const response = await API.post(CREATE_PRODUCT, data);

      return response?.data;
    } catch (err) {
      rollbar.error("Error message", err);
      return err;
    }finally {
      dispatch(updateLoading(false));
    }
  }
);
const fetchProducts = createAsyncThunk(
  seller_products,
  async (query, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch, { isAuthHeader: true });
    try {
      dispatch(updateLoading(true));
      const response = await API.get(GET_PRODUCT + query);

      return response?.data;
    } catch (err) {
      rollbar.error("Error message", err);
      return err;
    }finally {
      dispatch(updateLoading(false));
    }
  }
);

const fetchSellerProfile = createAsyncThunk(
  seller_profile,
  async (_, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch, { isAuthHeader: true });
    try {
      dispatch(updateLoading(true));
      const response = await API.get(SELLER_PROFILE);
      return response?.data;
    } catch (err) {
      rollbar.error("Error message", err);
      return err;
    }finally {
      dispatch(updateLoading(false));
    }
  }
);
const fetchEditSellerProfile = createAsyncThunk(
  seller_edit_profile,
  async (data, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch, { isAuthHeader: true });
    try {
      dispatch(updateLoading(true));
      const response = await API.patch(SELLER_PROFILE, data);
      return response?.data;
    } catch (err) {
      rollbar.error("Error message", err);
      return err;
    }finally {
      dispatch(updateLoading(false));
    }
  }
);
const fetchConnectStripe = createAsyncThunk(
  connect_stripe,
  async (_, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch, { isAuthHeader: true });
    try {
      const response = await API.post(GET_CONNECT_STRIPE);
      return response?.data;
    } catch (err) {
      rollbar.error("Error message", err);
      return err;
    }
  }
);

const fetchMigrateInventory = createAsyncThunk(
  migrate_inventory,
  async (data, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch, { isAuthHeader: true });
    try {
      const response = await API.post(MIGRATE_INVENTORY, data);
      return response?.data;
    } catch (err) {
      rollbar.error("Error message", err);
      return err;
    }
  }
);

const fetchEditProducts = createAsyncThunk(
  seller_edit_products,
  async (data, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch, { isAuthHeader: true });
    const id = data?.id;
    const dataToSend = data?.dataToSend
    try {
      dispatch(updateLoading(true));
      const response = await API.patch(GET_PRODUCT + id,  dataToSend);

      return response?.data;
    } catch (err) {
      rollbar.error("Error message", err);
      return err;
    }finally {
      dispatch(updateLoading(false));
    }
  }
);
const fetchGetProductById = createAsyncThunk(
  get_product_id,
  async (id, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch, { isAuthHeader: true });
    try {
      dispatch(updateLoading(true));
      const response = await API.get(GET_PRODUCT + id);

      return response?.data;
    } catch (err) {
      rollbar.error("Error message", err);
      return err;
    }finally {
      dispatch(updateLoading(false));
    }
  }
);
const fetchDeleteProduct = createAsyncThunk(
  seller_delete_products,
  async (id, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch, { isAuthHeader: true });
    try {
      dispatch(updateLoading(true));
      const response = await API.delete(GET_PRODUCT + id);

      return response?.data;
    } catch (err) {
      rollbar.error("Error message", err);
      return err;
    }finally {
      dispatch(updateLoading(false));
    }
  }
);
const fetchMarkShipped = createAsyncThunk(
  seller_mark_shipped,
  async (id, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch, { isAuthHeader: true });
    try {
      dispatch(updateLoading(true));
      const url = GET_SELLER_MARK_SHIPPED.replace(':id', id);
      const response = await API.patch(url);
      return response?.data;
    } catch (err) {
      rollbar.error("Error message", err);
      return err;
    }finally {
      dispatch(updateLoading(false));
    }
  }
);

const fetchStatus = createAsyncThunk(
  "Bag/getStatus",
  async (_, { dispatch, getState }) => {
    const API = getAuthorization(getState, {
      isAuthHeader: true,
      isSessionKey: true,
    });
    try {
      dispatch(updateLoading(true));
      const response = await API.get(STATUS_COLOR);
      dispatch(updateLoading(false));
      return response?.data;
    } catch (err) {
      rollbar.error("Error message", err);
      dispatch(updateLoading(false));
      throw err;
    }
  }
);

const fetchShopifyAccountCheck = createAsyncThunk(
  "shopify_account_check",
  async (_, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch, { isAuthHeader: true });
    try {
      const response = await API.get(SHOPIFY_ACCOUNT_CHECK);
      return response?.data;
    } catch (err) {
      if(err?.response?.status === 400){
        return err?.response?.data;
      } else if(err?.response?.status === 502){
        return "";
      } else {
        return err;
      }
    }
  }
);

// Fetch product variants
const fetchGetProductVariants = createAsyncThunk(
  get_product_variants,
  async (productId, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch, { isAuthHeader: true });
    try {
      dispatch(updateLoading(true));
      const url = PRODUCT_VARIANTS.replace(':id', productId);
      const response = await API.get(url);
      return response?.data;
    } catch (err) {
      rollbar.error("Error fetching product variants", err);
      return err;
    } finally {
      dispatch(updateLoading(false));
    }
  }
);

// Update product with option_types and option_values_dict
const fetchUpdateProductOptions = createAsyncThunk(
  update_product_options,
  async ({ productId, data }, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch, { isAuthHeader: true });
    try {
      dispatch(updateLoading(true));
      const response = await API.patch(GET_PRODUCT + productId, data);
      return response?.data;
    } catch (err) {
      rollbar.error("Error updating product options", err);
      return err;
    } finally {
      dispatch(updateLoading(false));
    }
  }
);

// Update product variants with variant_data using PATCH /v1/api/accounts/products/{id}
const fetchUpdateProductVariants = createAsyncThunk(
  update_product_variants,
  async ({ productId, variantData }, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch, { isAuthHeader: true });
    try {
      dispatch(updateLoading(true));
      // Use PATCH method with variant_data array
      const response = await API.patch(GET_PRODUCT + productId + "/", { variant_data: variantData });
      return response?.data;
    } catch (err) {
      rollbar.error("Error updating product variants", err);
      return err;
    } finally {
      dispatch(updateLoading(false));
    }
  }
);

// Update individual variant
const fetchUpdateVariant = createAsyncThunk(
  update_variant,
  async ({ variantId, data }, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch, { isAuthHeader: true });
    try {
      dispatch(updateLoading(true));
      const url = UPDATE_VARIANT.replace(':id', variantId);
      const response = await API.patch(url, data);
      return response?.data;
    } catch (err) {
      rollbar.error("Error updating variant", err);
      return err;
    } finally {
      dispatch(updateLoading(false));
    }
  }
);

// Delete variant
const fetchDeleteVariant = createAsyncThunk(
  delete_variant,
  async (variantId, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch, { isAuthHeader: true });
    try {
      dispatch(updateLoading(true));
      const url = DELETE_VARIANT.replace(':id', variantId);
      const response = await API.delete(url);
      return response?.data;
    } catch (err) {
      rollbar.error("Error deleting variant", err);
      return err;
    } finally {
      dispatch(updateLoading(false));
    }
  }
);

export {
  fetchCreateOptionType,
  fetchCreateOptionValue,
  fetchTags,
  fetchCreateProfile,
  fetchSellerProfile,
  fetchCollections,
  fetchCategories,
  fetchCreateProduct,
  fetchProducts,
  fetchConnectStripe,
  fetchFavProducts,
  fetchShopifyProfile,
  fetchOrders,
  fetchFilteredByStockProducts,
  fetchDashboardData,
  fetchOptionTypes,
  fetchEditProducts,
  fetchGetProductById,
  fetchDeleteProduct,
  fetchMarkShipped,
  fetchStatus,
  fetchEditSellerProfile,
  fetchShopifyList,
  fetchMigrateInventory,
  fetchShopifyStatus,
  fetchColours,
  fetchSizes,
  fetchAddColours,
  fetchAddSizes,
  fetchShopifyAccountCheck,
  fetchOptionTypeDetail,
  fetchGetProductVariants,
  fetchUpdateProductOptions,
  fetchUpdateProductVariants,
  fetchUpdateVariant,
  fetchDeleteVariant
};
